import type { DefaultTheme } from "styled-components";
import { resolveSelectionPalette } from "./TimelineSelection";
import type { MediaTimelineSegmentTone } from "./timelineTypes";

export const SEGMENT_FILL_PERCENT = 30;
export const ACTIVE_SEGMENT_FILL_PERCENT = 45;

/**
 * Both renderers resolve the same theme tokens (consumer overrides included) through the
 * selection palette, so a band and a selection in one hue cannot drift apart.
 */
export const segmentLineOf = (theme: DefaultTheme, tone: MediaTimelineSegmentTone): string =>
  resolveSelectionPalette(theme, tone).line;
